export default [
  {
    path: '/companies',
    name: 'companies',
    component: () => import('@/views/Companies/List/CompanyList'),
  }
]